import { RootState } from '@/store';
import { useSelector } from 'react-redux';
import { useTranslations } from 'next-intl';

const useDynamicTranslation = () => {
  const t = useTranslations('');
  const { keywords } = useSelector((state: RootState) => state.settings);

  const dt = (keyword: string | undefined) => {
    if (keyword === undefined) return '';
    return keywords[keyword] || t(keyword);
  };

  return { dt };
};

export default useDynamicTranslation;
